import { render, staticRenderFns } from "./PageCategoryModels.vue?vue&type=template&id=652c3690&scoped=true&"
import script from "./PageCategoryModels.vue?vue&type=script&lang=js&"
export * from "./PageCategoryModels.vue?vue&type=script&lang=js&"
import style0 from "./PageCategoryModels.vue?vue&type=style&index=0&id=652c3690&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c3690",
  null
  
)

export default component.exports